<p-calendar [ngModel]="value" (ngModelChange)="onValueChange($event)" [minDate]="minDate" [maxDate]="maxDate"
  [placeholder]="placeholder" [disabled]="disableControl" [showIcon]="showIcon" [dateFormat]="dateFormat"
  [iconDisplay]="iconDisplay" [panelStyleClass]="panelStyleClass" [readonlyInput]="false" [focusTrap]="false"
  [monthNavigator]="monthNavigator" [yearNavigator]="yearNavigator" [yearRange]="yearRange" [showButtonBar]="true"
  [inputStyleClass]="styleClass" (onShow)="setupCalendar()" (onClose)="onCalendarClose()">
</p-calendar>